import React, { Component } from "react";
import WidgetRow from "./widgetrow";
class Widgets extends Component {

  /* map the rows object recived from the server to a structure that the web app can pass around*/
  rowsOfWidgets = rowsStacksWidgets => {
    const ret = [];
    rowsStacksWidgets.forEach(r => {
      const meta = [];
      r.stacks.forEach(s => {
        s.widgets.forEach(w => {
          meta.push({ stack: s, widget: w });
        });
      });
      ret.push({ name: r.name, meta, weight: r.weight });
    });
    return ret;
  };

  render() {
    const { widgets, socket } = this.props;
    const rows = this.rowsOfWidgets(widgets);
    return (
      <React.Fragment>
        {rows.map(r => (
          <WidgetRow
            classes="row"
            socket={socket}
            key={r.name}
            identifier={r.name}
            meta={r.meta}
            weight={r.weight}
          >
          </WidgetRow>
        ))}
      </React.Fragment>
    );
  }
}

export default Widgets;
